import DefaultMapper from '../../dataProvider/DefaultMapper';

class BalanceTransactionMapper extends DefaultMapper {

	mapResource({ resource }) {
		return 'wallet/tx/balancetransactions';
	}

}

export default BalanceTransactionMapper;
